export const PAGE_SIZE_SEARCH = 15;
